export const Sloping = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="41"
      height="40"
      viewBox="0 0 41 40"
      fill="none"
    >
      <path
        opacity="0.24"
        d="M0 40V21.7872C0 8.39716 5.13221 1.19149 15.3966 0.170212L17.1266 0V9.02127L15.9156 9.19148C11.7637 9.64538 9.68776 13.4468 9.68776 20.5957V23.3191H17.1266V40H0ZM41 9.02127L39.789 9.19148C35.6371 9.64538 33.5612 13.4468 33.5612 20.5957V23.3191H41V40H23.8734V21.7872C23.8734 8.39716 29.0056 1.19149 39.27 0.170212L41 0V9.02127Z"
        fill="white"
      />
    </svg>
  );
};
